import React, { useState } from "react";
import { Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { sendingwines_support, vinologix_support } from "../config";
import AnimateWrapper from "../util/AnimateWrapper";
import BasicQuestion from "../util/BasicQuestion";
import { useBreadcrumbs } from "../util/BreadcrumbContext";
import ChoiceCard from "../util/ChoiceCard";

const DHLAccount = () => {
    const { state } = useLocation();
    const [showInstructions, setShowInstructions] = useState(false);
    const { addBreadcrumb } = useBreadcrumbs();
    const company = state.countryFrom === "NL" ? "Vinologix" : "SendingWines";
    const contact = !state.countryFrom
        ? vinologix_support
        : state.countryFrom === "NL"
        ? vinologix_support
        : sendingwines_support;

    return (
        <AnimateWrapper>
            <BasicQuestion
                question={`Heeft u al een DHL express account (MyDHL+) voor incoterm ${state.incoterm}?`}
                answers={
                    !showInstructions && (
                        <>
                            <Col xs={12} sm={6}>
                                <ChoiceCard
                                    body={"Ja"}
                                    onClick={() => {
                                        addBreadcrumb({
                                            href: "/instructions",
                                            text: "Instructies"
                                        });
                                    }}
                                />
                            </Col>
                            <Col xs={12} sm={6}>
                                <ChoiceCard
                                    body={"Nee"}
                                    onClick={() => {
                                        setShowInstructions(true);
                                    }}
                                />
                            </Col>
                        </>
                    )
                }
            />
            {showInstructions && (
                <div className="mt-3">
                    <h3>DHL Express Account</h3>
                    Voor verzendingen buiten de EU maken wij gebruik van DHL
                    Express. Per incoterm (DDP of DAP) is een account nodig.
                    Heeft u deze nog niet? Dan kunt u als volgt een account
                    aanvragen:
                    <ol>
                        <li>
                            <a
                                href={`mailto:${contact}?subject=DHL Express acount (${state.incoterm})&body=Beste,%0D%0A%0D%0AIk zou graag een verzending buiten de EU willen doen met incoterm ${state.incoterm}, zouden jullie hiervoor een DHL express account aan kunnen maken?`}
                            >
                                Vraag {company} om een DHL Express account.
                            </a>{" "}
                            Geef aan dat het hier gaat om incoterm{" "}
                            {state.incoterm}.
                        </li>
                        <li>
                            Wacht totdat het account is aangemaakt door{" "}
                            {company}.
                        </li>
                        <li>
                            U ontvangt een email van DHL Express ("Authorisation
                            to use DHL account").
                        </li>
                        <li>Klik op "Register for MyDHL+".</li>
                        <li>
                            {company} mailt u de handleiding voor het gebruik
                            van MyDHL+ paperless trade.
                        </li>
                        <li>
                            Bij het activeren van paperless trade wordt gevraagd
                            uw handtekening te uploaden als .jpeg bestand.
                        </li>
                        <li>
                            Bij "Heeft u een DHL account nummer", selecteer
                            "Nee".
                        </li>
                        <li>
                            Bij "Wilt u een DHL account aanvragen", selecteer
                            "Nee".
                        </li>
                        <li>
                            Bij "Your Details", vul je bedrijfsnaam in en het
                            06-nummer zonder de '0'.
                        </li>
                        <li>
                            Kies als password het wachtwoord dat u bij de{" "}
                            {company} website gebruikt met daarachter "@Vino9".
                        </li>
                        <li>
                            Accepteer de terms and conditions en klik op
                            "register".
                        </li>
                        <li>
                            U ontvangt een email "Activeer uw MyDHL+
                            registratie".
                        </li>
                        <li>
                            Klik op de groene knop, log in en klik op "Accept
                            and Continue"
                        </li>
                        <li>
                            U krijgt nu een scherm "Selecteer Groep en
                            Standaarden"
                        </li>
                        <li>Vink "Authorisation Name" aan als standaard.</li>
                        <li>Klik op "Selecteer".</li>
                        <li>
                            U kunt nu aan de slag, zie de handleiding MyDHL+
                            voor meer informatie.
                        </li>
                    </ol>
                    <ChoiceCard
                        body={"Ga verder"}
                        onClick={() => {
                            addBreadcrumb({
                                href: "/instructions",
                                text: "Instructies"
                            });
                        }}
                    />
                </div>
            )}
        </AnimateWrapper>
    );
};

export default DHLAccount;
